<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-row>
            <v-col>
                <v-card class="elevation-6">
                    <v-card-title>Επιλεγμένα Σημεία Διανομής</v-card-title>
                        <v-data-table :key="bothTableRerender"
                                :headers="headers"
                                :items="$store.getters.selectedDistPoint.BookDistPointList"
                                :items-per-page="5"
                                class="elevation-1"
                                return-object
                                no-data-text="Δεν υπάρχουν δεδομένα.">

                            <template v-slot:item.distributionPointName="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on">
                                            <v-chip v-if="!item.hasMembership"
                                                    color="red" outlined class="my-1"
                                                    dense shaped
                                                    style="max-width: 120ch;text-wrap: normal">
                                                <v-icon left size="21" class="mr-1">mdi-alert-outline</v-icon>
                                                <span class="text-truncate">{{ item.distributionPointName }}</span>
                                            </v-chip>

                                            <span v-else>{{ item.distributionPointName }}</span>
                                        </div>
                                    </template>

	                                <span v-if="!item.hasMembership">Το σημείο διανομής δεν έχει επιβεβαιώσει τη συμμετοχή του για φέτος</span>
	                                <span v-else>Το σημείο διανομής έχει επιβεβαιώσει τη συμμετοχή του για φέτος</span>
                                </v-tooltip>
                            </template>


                            <template v-slot:item.actions="{ item }">
                                <v-tooltip left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-on="on"
                                                @click="deleteDistPoint(item)"
                                                color="red"
                                                class="mr-2">delete</v-icon>
                                    </template>
                                    <span>Διαγραφή Σημείου Διανομής</span>
                                </v-tooltip>
                            </template>

                        </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="elevation-6">
                    <v-card-title>Διαθέσιμα Σημεία Διανομής</v-card-title>
                    <v-data-table :key="bothTableRerender"
                            :headers="headers"
                            :items="$store.getters.selectedDistPoint.PublisherDistPointList"
                            :items-per-page="5"
                            class="elevation-1"
                            return-object
                            no-data-text="Δεν υπάρχουν δεδομένα.">
                        <template v-slot:item.distributionPointName="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                        <v-chip v-if="!item.hasMembership"
                                                color="red" outlined class="my-1"
                                                dense shaped
                                                style="max-width: 120ch;text-wrap: normal">
                                            <v-icon left size="21" class="mr-1">mdi-alert-outline</v-icon>
                                            <span class="text-truncate">{{ item.distributionPointName }}</span>
                                        </v-chip>

                                        <span v-else>{{ item.distributionPointName }}</span>
                                    </div>
                                </template>

                                <span v-if="!item.hasMembership">Το σημείο διανομής δεν έχει επιβεβαιώσει τη συμμετοχή του για φέτος</span>
                                <span v-else>Το σημείο διανομής έχει επιβεβαιώσει τη συμμετοχή του για φέτος</span>
                            </v-tooltip>
                        </template>

                        <template v-slot:item.actions="{ item }">

                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">

                                    <v-icon :color="checkIfDistPointIsExist(item)? 'lightSeaGreen':'cyan'" :disabled="!item.hasMembership"
                                            @click="checkIfDistPointIsExist(item)?addDistPoint(item):''"
                                            v-on="on"
                                            class="mr-2">{{checkIfDistPointIsExist(item)? 'mdi-map-marker-plus' : 'done_all'}}
                                    </v-icon>
                                </template>
                                <span>{{checkIfDistPointIsExist(item)? 'Προσθήκη Σημείου Διανομής' : 'Έχει Προστεθεί στα Σημεία Διανομής'}}</span>
                            </v-tooltip>



                        </template>
<!--                        <template v-slot:item.actions="{ item }">-->
<!--                            <v-tooltip left v-if="checkIfDistPointIsExist(item)">-->
<!--                                <template v-slot:activator="{ on, attrs}">-->
<!--                                    <v-icon color="green"-->
<!--                                            @click="addDistPoint(item)"-->
<!--                                            v-on="on"-->
<!--                                            class="mr-2">add</v-icon>-->
<!--                                </template>-->
<!--                                <span>Προσθήκη Σημείου Διανομής</span>-->
<!--                            </v-tooltip>-->
<!--                            <v-tooltip left v-else>-->
<!--                                <template v-slot:activator="{ on, attrs}">-->
<!--                                    <v-icon-->
<!--                                            color="cyan"-->
<!--                                            v-on="on"-->
<!--                                            class="mr-2">done_all</v-icon>-->
<!--                                </template>-->
<!--                                <span>Έχει Προστεθεί στα Σημεία Διανομής</span>-->
<!--                            </v-tooltip>-->
<!--                        </template>-->

                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>

    import utils from '../../utilities'
    import request from '../../requests'

    export default {
        name: "DistributionPointArray",
        data: () => ({
            utils,
            headers: [
                {
                    text: 'Νομός',
                    align: 'start',
                    sortable: false,
                    value: 'prefectureName',
                },
                { text: 'Δήμος', value: 'cityName', align:'center' },
                { text: 'Κωδικός', value: 'id', align:'center' },
                { text: 'Τίτλος', value: 'distributionPointName', align:'center' },
                { text: 'Ενέργειες', value: 'actions', align:'center' },
            ],
            bothTableRerender:0,
        }),

        props: {
            academicYearSelect: Object,
            selectedObj: Object
        },

        methods: {

            //check if dist point from second array is exist in firs array
            checkIfDistPointIsExist(PublisherDistPointList){

                var BookDistPointList = this.$store.getters.selectedDistPoint.BookDistPointList;

                for (var i = 0; i < BookDistPointList.length; i++){
                    if (BookDistPointList[i].id == PublisherDistPointList.id){
                        return false;
                    }
                }
                return true;
            },

            createCourseBookDistPoint(item) {

                var courseBookDistPoint = {
                    bookID: this.selectedObj.bookID,
                    courseID: this.selectedObj.course.id,
                    distributionPointIDs: [item.id]
                };
                return courseBookDistPoint;
            },

        //    delete dist point
            deleteDistPoint(item){

                var courseBookDistPoint = this.createCourseBookDistPoint(item);

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.deleteDistributionPoint(token, courseBookDistPoint, this.deleteDistributionPointCallBack);
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            deleteDistributionPointCallBack(response){

                var selectedDistPoint = this.$store.getters.selectedDistPoint;
                selectedDistPoint.BookDistPointList = response.slice();
                this.$store.commit('setSelectedDistPoint', selectedDistPoint);
                this.$store.commit('setLoadingModal', false);
            },

        //    add Dist Point
            addDistPoint(item){
                document.activeElement.blur();
                var courseBookDistPoint = this.createCourseBookDistPoint(item);

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.addDistributionPoint(token, courseBookDistPoint, this.addDistributionPointCallBack);
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            addDistributionPointCallBack(response) {

                var selectedDistPoint = this.$store.getters.selectedDistPoint;
                selectedDistPoint.BookDistPointList = response.slice();
                this.$store.commit('setSelectedDistPoint', selectedDistPoint);
                this.$store.commit('setLoadingModal', false);
            }
        },
        watch:{
            'selectedObj' (){
                this.bothTableRerender++;
            }
        },
    }
</script>

<style scoped>

</style>